import { firebaseAuth } from '../config/firebase';

export const Logout = () => {
    firebaseAuth
      .signOut()
      .then(() => {})
      .catch(e => {
        console.log(e);
      });
};


export const getLoggedUser = ()=> {
  return new Promise((resolve) => {
    firebaseAuth.onAuthStateChanged((user) => {
      if (user) {

        const formatedUserData = {
          uid: user.uid,
          name: user.displayName,
          image: user.photoURL,
          email: user.email
        }

       return resolve(formatedUserData)
      
      }
      resolve(null);
    });
  });
}

export const uidUser = ()=> {
  return new Promise((resolve, reject) => {
    firebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        resolve(user.uid)
      } else {
        reject("user not found")
      }
    });
  });
}